import { create } from "zustand";
import moment from "moment-timezone";

interface TimezoneStoreType {
  timezone: string | undefined;
  setTimezone: (timezone: string) => void;
}

export const useTimezoneStore = create<TimezoneStoreType>((set) => ({
  timezone: undefined,
  setTimezone: (timezone) =>
    set(() => {
      moment.tz.setDefault(timezone);
      return { timezone: timezone };
    }),
}));
